(function () {
    "use strict";

    var CustomPanelsPartControl = Solovis.defineClass(
        "Solovis.Reports.Parts.CustomPanels.CustomPanelsPartControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            var self = this;

            this._newControlsSupported = false;
            this._persistedSettings = options.persistedSettings ? options.persistedSettings : null;

            if (this._persistedSettings) {
                if (this._persistedSettings.parameters) {
                    this._parameters = this._persistedSettings.parameters;

                    if (this._persistedSettings.parameterValues) {
                        var paramValues = this._persistedSettings.parameterValues;
                        $(this._parameters).each(function (i, param: any) {
                            if (Solovis.isNotNull(paramValues[param.name])) {
                                param.initialValue = paramValues[param.name];
                            }
                        });
                    }
                }
            }

            if (!this._parameters) {
                this._parameters = [];
            }

            this._createNewParameterSet();
        });

    CustomPanelsPartControl.requiredModules = ["Solovis.ReportStackEditor"];

    CustomPanelsPartControl.prototype.doInit = function () {
    };

    CustomPanelsPartControl.prototype.doRender = async function () {
        if (this._notFirstRender) {
            return;
        }
        this._notFirstRender = true;
        const enabled = Solovis.UX.Utils.areNewControlsSupported();
        if (enabled) {
            this.doRenderNew();
        } else {
            this.doRenderClassic();
        }
    }

    CustomPanelsPartControl.prototype.doRenderNew = async function () {
        this.doRenderClassic();
        this._configSection.addClass("slvs-panel");
    }

    CustomPanelsPartControl.prototype.doRenderClassic = async function () {
        this._configSection = $("<div>");

        var self = this;

        this._configSection.addClass("report-config-section no-print").appendTo(this.container);
        this._paramListContainer = $("<div>").appendTo(this._configSection);
        
        this._updateParameterListControl();
        
        if (this.reportControl.isTopLevelReportControl()) {
            var actionBarDiv = $("<div>");

            var addPanelButton = $("<button>").text("Add Panel").appendTo(actionBarDiv);
            addPanelButton.click(function () {
                self.showPanelAddDialog();
            });

            var panelOptionsLink = $("<a>").html('<span class="fa fa-bars"></span>').appendTo(actionBarDiv);
            panelOptionsLink.click(function () {
                self._showOptionsMenu(panelOptionsLink);
            });

            var actionBarRegionForAddPanelButton = Solovis.Site.ActionBar.getOrCreateRegion("CustomPanelsAddPanelButton");
            actionBarRegionForAddPanelButton.setHtml(addPanelButton);

            var actionBarRegionForOptionsMenu = Solovis.Site.ActionBar.getOrCreateRegion("CustomPanelsOptionsMenu");
            actionBarRegionForOptionsMenu.setHtml(panelOptionsLink);
        }

        this.panelSetDiv = $("<div>").appendTo(this.container)
            .css("position", "relative");

        this._panelList = [];
        

        // We have to do the setTimeout callback to initialize panels, or we
        // the jquery resize handles end up in the wrong place (possibly a jquery
        // bug or maybe some odd html quirk, but this is the workaround).
        if (self._persistedSettings && self._persistedSettings.panels) {
            setTimeout(function () {
                $(self._persistedSettings.panels).each(function (i, panelState) {
                    // TODO: Add strongly typed reference once fully converted to typescript.
                    var panel = new (Solovis.Reports.Parts as any).CustomPanels.ResizableReportPanel({
                        parentReportControl: self.reportControl,
                        customPanelsControl: self,
                        panelSetDiv: self.panelSetDiv,
                        panelState: panelState
                    });

                    self._panelList.push(panel);
                });
            }, 50);
        }
        

        // When Custom Panels is a top-level report, we support dropping reports onto the window.
        if (this.reportControl.isTopLevelReportControl()) {
            // TODO: Consider support dropping reports when Custom Panels is not top-level.
            Solovis.Site.DragDropManager.setupSolovisRefDrop(window, function (solovisRef) {
                if (solovisRef.type == "report") {
                    var reportRef = solovisRef.value;
                    if (reportRef.code) {
                        self._addReportPanelByReportCode(reportRef.code);
                    }
                }
            });

            Solovis.Site.DragDropManager.setupSolovisReportDrop(window, function (reportRef) {
                if (reportRef.reportCode) {
                    var moreOptions = {
                        parameters: reportRef.parameters,
                        persistedSettings: reportRef.persistedSettings
                    };
                    self._addReportPanelByReportCode(reportRef.reportCode, moreOptions);
                }
            });
        }
    };


    CustomPanelsPartControl.prototype._createNewParameterSet = function () {
        var self = this;

        this._parameterSet = new Solovis.Reports.ParameterSet({
            parameters: this._parameters
        });

        $(this._parameterSet).bind("parameterValueChanged", function (e, data) {
            var valuesChanged = [];
            if (data.name) {
                valuesChanged.push(data.name);
            }

            self._applyParametersToAllPanels(valuesChanged);
        } as any);
    };

    CustomPanelsPartControl.prototype._updateParameters = function (newParameters) {
        this._parameters = newParameters;

        // Copy parameter values over from old parameters.
        if (this._parameterSet) {
            var priorValues = this._parameterSet.getParameterValues();            
            $(this._parameters).each(function (i, param: any) {
                if (Solovis.isNotNull(priorValues[param.name])) {
                    param.initialValue = priorValues[param.name];
                }
            });
        }
   
        this._createNewParameterSet();        
        this._updateParameterListControl();
    };

    CustomPanelsPartControl.prototype._updateParameterListControl = function () {
        var paramListControl = new Solovis.Reports.Parameters.ParameterListControl({
            controlHost: this._paramListContainer,
            parameterSet: this._parameterSet
        });
        paramListControl.setAsCurrentControl();

        if (!this._parameters || this._parameters.length == 0) {
            this._configSection.toggle(false);
        }
        else {
            this._configSection.toggle(true);
        }
    };


    CustomPanelsPartControl.prototype.getPersistedSettings = function () {
        var panelSettingsList = [];

        $(this._panelList).each(function (i, panel: any) {
            var panelSettings = panel.getPersistedState();
            panelSettingsList.push(panelSettings);
        });

        var parameterValues = null;
        if (this._parameterSet) {
            parameterValues = this._parameterSet.getSerializedParameterValues();
        }

        var persistedSettings = {
            parameters: this._parameters,
            parameterValues: parameterValues,
            panels: panelSettingsList
        };

        return persistedSettings;
    };


    CustomPanelsPartControl.prototype._getTopForNewPanel = function () {
        var nextTop = 0;

        var listTop = this.panelSetDiv.offset().top;

        $(this._panelList).each(function (i, panel: any) {
            var offset = panel.resizableContainer.offset();

            var top = offset.top;
            var height = panel.resizableContainer.height();
            
            var bottom = (top - listTop) + height;

            if (bottom > nextTop) {
                nextTop = bottom;
            }
        });

        return nextTop;
    };


    CustomPanelsPartControl.prototype.removePanel = function (reportPanel) {
        if (!reportPanel) {
            throw "reportPanel not specified";
        }

        this._panelList = _.filter(this._panelList, function (panel) { return panel !== reportPanel });
        reportPanel.destroy();
    };


    CustomPanelsPartControl.prototype._applyParametersToAllPanels = function (valuesChanged) {
        var paramValues = this._parameterSet.getParameterValues();

        $(this._panelList).each(function (i, panel: any) {
            panel.applyParameterValues(paramValues, valuesChanged);
        });
    };


    CustomPanelsPartControl.prototype.showParameterListEditor = function () {
        var self = this;
        (Solovis.Reports as any).ReportStacks.ParameterListEditorControl.showDialog(
            {
                parameters: self._parameters
            },
            function (updatedParameters) {
                self._updateParameters(updatedParameters);                
            });
    };

    CustomPanelsPartControl.prototype.showPanelAddDialog = function () {
        var self = this;
        Solovis.InvDataSelectors.ReportSelectorDialog.selectReport(function (reportInfo) {
            if (reportInfo && reportInfo.code) {
                self._addReportPanelByReportCode(reportInfo.code);
            }
        });
    };

    CustomPanelsPartControl.prototype._addReportPanelByReportCode = function (reportCode, moreOptions) {
        var self = this;

        var nextTop = self._getTopForNewPanel();

        var parametersToUse = null;
        var defaultPersistedSettingsToUse = null;
        if (moreOptions) {
            if (moreOptions.parameters) {
                parametersToUse = moreOptions.parameters;
            }
            if (moreOptions.persistedSettings) {
                defaultPersistedSettingsToUse = moreOptions.persistedSettings;
            }
        }

        // TODO: Add strongly typed reference once fully converted to typescript.
        var panel = new (Solovis.Reports.Parts as any).CustomPanels.ResizableReportPanel({
            parentReportControl: self.reportControl,
            customPanelsControl: self,
            panelSetDiv: self.panelSetDiv,
            reportCode: reportCode,
            initialTop: nextTop,
            parameters: parametersToUse,
            defaultPersistedSettings: defaultPersistedSettingsToUse
        });

        self._panelList.push(panel);
    };

    CustomPanelsPartControl.prototype._showOptionsMenu = function (offsetElement) {
        var self = this;
        
        offsetElement.addClass("active");

        var linkPanel = Solovis.UI.PopupLinkPanel.showLinks({
            offsetElement: offsetElement,
            offsetRight: true,
            offsetBottom: true,
            fromRightEdge: true,
            links: [
                { 
                    label: "Edit Parameters", 
                    click: function () {
                        self.showParameterListEditor();
                    }
                },
                {
                    label: "Panel List",
                    click: function () {
                        self._showPanelList();
                    }
                }
            ],

            close: function () {
                offsetElement.removeClass("active");
            }
        });
    };


    CustomPanelsPartControl.prototype._showPanelList = function () {
        var self = this;
        var dialogDiv = $("<div>");

        var refreshPanelList = function () {
            dialogDiv.html("");

            $(self._panelList).each(function (i, resizeableReportPanel: any) {
                var panelDiv = $("<div>");

                var panelTitle = resizeableReportPanel.headerTitle.text();

                $("<span>").text(panelTitle).appendTo(panelDiv);

                $("<a>").text("Remove").appendTo(panelDiv)
                    .css("padding-left", "10px")
                    .click(function () {
                        resizeableReportPanel.destroy();
                        refreshPanelList();
                    });

                $("<a>").text("Bring To Front").appendTo(panelDiv)
                    .css("padding-left", "8px")
                    .click(function () {
                        resizeableReportPanel.bringToFront();
                        refreshPanelList();
                    });

                dialogDiv.append(panelDiv);
            });
        };

        refreshPanelList();

        var desiredWidth = 500;
        var desiredHeight = 400;

        var dialog = new Solovis.UI.Dialog({
            container: dialogDiv,

            title: "Panel List",
            autoOpen: true,
            actions: ["Close"],

            width: desiredWidth,
            height: desiredHeight,
            center: true,

            buttons: [
                {
                    label: "Close",
                    click: function () {
                        dialog.close();
                    }
                }
            ],

            destroyOnClose: true
        });
    };

})();